/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import * as Api from '../../../api/Api';
import AddRole from './add-role';
import RemoveRole from './remove-role';

import { Unauthorized } from '../../Global/unauthorized';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { PageTitle } from '../../../../_metronic/layout/core'
import EditRole from './edit-role';
import { useGetToken } from '../../../Hooks/CustomHooks';
import AgTable from '../../../Components/Table/AgTable';

export default function ListRole({ title }) {

    const [showAddRole, setShowAddRole] = useState(false);
    const [showEditRole, setShowEditRole] = useState(false);
    const [showRemoveRole, setShowRemoveRole] = useState(false);

    const [roleEdit, setRoleEdit] = useState({});
    const [roleRemove, setRoleRemove] = useState({});

    const [refreshTable, setRefreshTable] = useState(true);

    let token = useGetToken();

    const header = [
        {
            headerName: 'Nombre',
            field: 'name',
            width: 350,
            cellRenderer: (props) => (
                <div className="align-items-left d-flex h-100 justify-content-left">
                    <span value={props.data.name} className="text-gray-800 mb-1 nombre-user">{props.data.name}</span>
                </div>
            )
        },
        {
            headerName: 'Editar',
            //1Width: 50,
            cellRenderer: (props) => (
                <a onClick={() => {
                    setRoleEdit(props.data);
                    setShowEditRole(true);
                }} className="btn btn-light btn-active-light-primary btn-sm">
                    <i className="fi-rr-pencil"></i>
                </a>
            )
        },
        {
            headerName: 'Eliminar',
            //Width: 50,
            cellRenderer: (props) => (
                <a onClick={() => {
                    setRoleRemove(props.data);
                    setShowRemoveRole(true);
                }} className="btn bg-danger-mall btn-sm">
                    <i className="fi-rr-remove-user text-red-mall"></i>
                </a>
            )
        }
    ]

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GESTION_ROLES]} >
                <PageTitle>{title}</PageTitle>
                <div className='d-flex flex-stack'>
                    <div className="d-flex flex-column justify-content-center flex-wrap me-3">
                        <h3 className="fw-bolder my-2">Lista de funciones</h3>
                        <span className='text-muted fw-semibold fs-7 my-0 pt-1'>Gestión de usuarios - Roles</span>

                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <div className="">
                            <button className="btn btn-sm btn-primary btn-active-primary" onClick={() => { setShowAddRole(true) }}><span className="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1" transform="rotate(-90 11.364 20.364)" fill="black"></rect>
                                    <rect x="4.36396" y="11.364" width="16" height="2" rx="1" fill="black"></rect>
                                </svg>
                            </span> Crear Rol</button>
                            <AddRole setShowAddRole={setShowAddRole} showAddRole={showAddRole} setRefreshData={setRefreshTable} />
                            <EditRole roleEdit={roleEdit} setRoleEdit={setRoleEdit} setShowEditRole={setShowEditRole} showEditRole={showEditRole} setRefreshData={setRefreshTable} />
                            <RemoveRole roleRemove={roleRemove} setShowRemoveRole={setShowRemoveRole} showRemoveRole={showRemoveRole} setRefreshData={setRefreshTable} />

                        </div>
                    </div>
                </div>
                <div className="card my-5">

                    <div className="card-body tab-content">
                        <AgTable
                            idContent={"rolesTable"}
                            apiService={Api.getRoleList}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Roles"}
                            conditions={refreshTable}
                            args={{ token: token }}
                            hideFilter={false}
                            paginationPageSize={20}
                            rowHeight={40}
                            useFlex = {false}
                            
                        />
                    </div>
                </div>

            </PermissionsGate>
        </>
    )
}